import { Avatar as JoyAvatar, CircularProgress } from '@mui/joy'
import Lightbox from 'yet-another-react-lightbox'
import Zoom from 'yet-another-react-lightbox/plugins/zoom'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { useImgLoad } from '~/shared/ui/Img'
import { useModal } from '~/shared/ui/Modal'
import { Wrapper } from './styled'
import 'yet-another-react-lightbox/styles.css'

type AvatarProps = {
  url?: string
  isLoading?: boolean
}

export function Avatar({ url, isLoading }: AvatarProps) {
  const { isModalShow, closeModal, openModal } = useModal()
  const { imageUrl, isLoading: isImageLoading } = useImgLoad(url)

  const loading = isLoading || isImageLoading

  const handleWarning = () => {
    snackbarEnqueued({
      messageI18n: 'alert.driver photo not found',
      variant: 'warning',
    })
  }

  return (
    <Wrapper>
      {loading && <CircularProgress size='sm' />}
      {!loading && (
        <JoyAvatar
          src={imageUrl}
          onClick={imageUrl ? openModal : handleWarning}
        />
      )}

      {imageUrl && (
        <Lightbox
          carousel={{
            finite: true,
          }}
          slides={[{ src: imageUrl }]}
          open={isModalShow}
          close={closeModal}
          plugins={[Zoom]}
          animation={{ zoom: 300 }}
          zoom={{ maxZoomPixelRatio: 10, scrollToZoom: true }}
        />
      )}
    </Wrapper>
  )
}
